var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActiveOrderCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F6EEED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.19 14H19.81C16.17 14 14 16.17 14 19.81V28.19C14 31.83 16.17 34 19.81 34H28.19C31.83 34 34 31.83 34 28.19V19.81C34 16.17 31.83 14 28.19 14ZM21.97 26.9L19.72 29.15C19.57 29.3 19.38 29.37 19.19 29.37C19 29.37 18.8 29.3 18.66 29.15L17.91 28.4C17.61 28.11 17.61 27.63 17.91 27.34C18.2 27.05 18.67 27.05 18.97 27.34L19.19 27.56L20.91 25.84C21.2 25.55 21.67 25.55 21.97 25.84C22.26 26.13 22.26 26.61 21.97 26.9ZM21.97 19.9L19.72 22.15C19.57 22.3 19.38 22.37 19.19 22.37C19 22.37 18.8 22.3 18.66 22.15L17.91 21.4C17.61 21.11 17.61 20.63 17.91 20.34C18.2 20.05 18.67 20.05 18.97 20.34L19.19 20.56L20.91 18.84C21.2 18.55 21.67 18.55 21.97 18.84C22.26 19.13 22.26 19.61 21.97 19.9ZM29.56 28.62H24.31C23.9 28.62 23.56 28.28 23.56 27.87C23.56 27.46 23.9 27.12 24.31 27.12H29.56C29.98 27.12 30.31 27.46 30.31 27.87C30.31 28.28 29.98 28.62 29.56 28.62ZM29.56 21.62H24.31C23.9 21.62 23.56 21.28 23.56 20.87C23.56 20.46 23.9 20.12 24.31 20.12H29.56C29.98 20.12 30.31 20.46 30.31 20.87C30.31 21.28 29.98 21.62 29.56 21.62Z",
    fill: "#8D5245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActiveOrderCardIcon);
export default __webpack_public_path__ + "static/media/dashboard-active-order-card-icon.1b7d31c28d2d2ee406846b6d9804902d.svg";
export { ForwardRef as ReactComponent };